import { createContext, use, useMemo, useState, type ReactNode } from "react";
import { clearMasterKey, restoreSessionKey, setMasterKey } from "../../lib/api";

interface AuthContextValue {
  authenticated: boolean;
  signIn: (key: string, rememberForSession: boolean) => void;
  signOut: () => void;
}

const AuthContext = createContext<AuthContextValue | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [authenticated, setAuthenticated] = useState(() => restoreSessionKey().length > 0);
  const value = useMemo<AuthContextValue>(
    () => ({
      authenticated,
      signIn(key, rememberForSession) {
        setMasterKey(key, rememberForSession);
        setAuthenticated(true);
      },
      signOut() {
        clearMasterKey();
        setAuthenticated(false);
      }
    }),
    [authenticated]
  );
  return <AuthContext value={value}>{children}</AuthContext>;
}

export function useAuth(): AuthContextValue {
  const value = use(AuthContext);
  if (!value) throw new Error("useAuth must be used inside AuthProvider");
  return value;
}
